(() => {
  const SELECTOR = '.agoga-footer';
  const MOBILE_QUERY = window.matchMedia('(max-width: 749px)');

  function setPanelState(item, open, mobileMode) {
    const button = item.querySelector('.agoga-footer__menu-toggle');
    const panel = item.querySelector('.agoga-footer__menu-panel');
    if (!button || !panel) return;

    if (!mobileMode) {
      button.setAttribute('aria-expanded', 'true');
      item.classList.remove('is-open');
      panel.style.removeProperty('height');
      panel.style.removeProperty('--agoga-panel-height');
      return;
    }

    button.setAttribute('aria-expanded', String(open));
    item.classList.toggle('is-open', open);

    if (open) {
      panel.style.setProperty('--agoga-panel-height', `${panel.scrollHeight}px`);
      panel.style.height = `${panel.scrollHeight}px`;
    } else {
      panel.style.height = '0px';
    }
  }

  function refreshFooterMode(footer) {
    const accordions = [...footer.querySelectorAll('[data-footer-accordion]')];
    const mobileMode = MOBILE_QUERY.matches;

    accordions.forEach((item) => {
      const isOpen = item.classList.contains('is-open');
      setPanelState(item, mobileMode ? isOpen : true, mobileMode);
    });
  }

  function initFooter(footer) {
    if (!footer || footer.dataset.initialized === 'true') return;
    footer.dataset.initialized = 'true';

    const accordions = [...footer.querySelectorAll('[data-footer-accordion]')];
    const allowMultiple = footer.dataset.allowMultiple === 'true';

    accordions.forEach((item) => {
      const button = item.querySelector('.agoga-footer__menu-toggle');
      if (!button) return;

      button.addEventListener('click', () => {
        if (!MOBILE_QUERY.matches) return;
        const willOpen = button.getAttribute('aria-expanded') !== 'true';

        if (!allowMultiple) {
          accordions.forEach((otherItem) => {
            if (otherItem !== item) setPanelState(otherItem, false, true);
          });
        }

        setPanelState(item, willOpen, true);
      });
    });

    refreshFooterMode(footer);

    const revealTargets = footer.querySelectorAll(
      '.agoga-footer__brand,.agoga-footer__menus,.agoga-footer__newsletter,.agoga-footer__bottom'
    );
    revealTargets.forEach((target) => target.setAttribute('data-footer-reveal', ''));

    if (!('IntersectionObserver' in window)) {
      revealTargets.forEach((target) => target.classList.add('is-visible'));
    } else {
      const observer = new IntersectionObserver((entries, io) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        });
      }, { threshold: .12 });
      revealTargets.forEach((target) => observer.observe(target));
    }

    const backToTop = footer.querySelector('[data-back-to-top]');
    if (backToTop) {
      const toggle = () => backToTop.classList.toggle('is-visible', window.scrollY > 500);
      toggle();
      window.addEventListener('scroll', toggle, { passive: true });
      backToTop.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    const handleResize = () => refreshFooterMode(footer);
    window.addEventListener('resize', handleResize, { passive: true });
    MOBILE_QUERY.addEventListener?.('change', handleResize);
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(initFooter);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', (event) => {
    const footer = event.target.querySelector(SELECTOR);
    initFooter(footer);
  });
})();
